<template>
  <LISAInput
    v-bind="{
      ...$attrs,
      ...$props,
    }"
    autocomplete="new-password"
    :type="visible ? 'text' : 'password'"
  >
    <template #append>
      <LISAButton
        :icon="visible ? 'fas fa-eye' : 'fas fa-eye-slash'"
        text
        full-width
        full-height
        @click="visible = !visible"
      ></LISAButton>
      <slot name="append" />
    </template>
    <template v-if="'prepend' in $slots" #prepend>
      <slot name="prepend" />
    </template>
  </LISAInput>
</template>

<script setup lang="ts">
import { LISAInput } from "@fi-solutions/lisa-ui";
import { ref } from "vue";
import LISAButton from "./primevue/LISAButton.vue";

const visible = ref(false);
</script>
